import * as React from 'react'
import { defineMessages, FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import Button from '../../../../components/button'

import styles from './hero.module.scss'

export const messages = defineMessages({
  // button: {
  //   defaultMessage: "Jag har spelat klart",
  //   id: "404.hero.button"
  // },
  button: {
    defaultMessage: 'ok, guida mig rätt!',
    id: '404.hero.button',
  },
  heading: {
    defaultMessage: 'Hoppsan! Du verkar ha klickat på någon trasig länk.',
    id: '404.hero.heading',
  },
  // lede: {
  //   defaultMessage:
  //     "Eller så skrev du kanske in fel webbadress. Något knas blev det iallafall. Men nu är du här, så ta och spela lite pong innan du surfar vidare! Eftersom något blev fel får du lite bonuspoäng att starta med.<br /><br />Lycka till!",
  //   id: "404.hero.lede"
  // },
  lede: {
    defaultMessage: 'Eller så skrev du kanske in fel webbadress. Något knas blev det iallafall.',
    id: '404.hero.lede',
  },
})

export default function NotFound() {
  return (
    <div className={styles.root}>
      <h1 className={styles.heading}>
        <FormattedMessage {...messages.heading} />
      </h1>
      <p className={styles.lede}>
        <FormattedHTMLMessage {...messages.lede} />
      </p>
      <Button className={styles.button} href="/pris">
        <FormattedMessage {...messages.button} />
      </Button>
    </div>
  )
}
